import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { authService } from '../services/api';
import { toast } from 'sonner';

export const LoginPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [resterConnecte, setResterConnecte] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const userData = await authService.login(email, password, resterConnecte);
      toast.success('Connexion réussie');
      if (userData?.must_change_password) {
        navigate('/changer-mot-de-passe');
      } else {
        navigate('/dashboard');
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erreur de connexion');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex" data-testid="login-page" style={{ background: '#0B132B' }}>
      {/* Left side - Branding */}
      <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden items-center justify-center" style={{ background: '#0B132B' }}>
        <div className="absolute inset-0 opacity-30" style={{ background: 'radial-gradient(circle at 30% 40%, rgba(59,130,246,0.15) 0%, transparent 60%), radial-gradient(circle at 70% 70%, rgba(99,102,241,0.1) 0%, transparent 50%)' }} />
        <div className="relative z-10 text-center px-12">
          <h1 className="text-7xl font-bold text-white font-heading tracking-tight mb-4">Eva</h1>
          <p className="text-sm text-slate-400 uppercase tracking-[0.3em]">by ASAP Technologies</p>
          <div className="mt-12 w-24 h-px bg-gradient-to-r from-transparent via-blue-500 to-transparent mx-auto" />
          <p className="mt-8 text-lg text-slate-300 font-light leading-relaxed max-w-sm mx-auto">
            Plateforme d&apos;évaluation technique intelligente
          </p>
        </div>
      </div>

      {/* Right side - Login form */}
      <div className="w-full lg:w-1/2 flex items-center justify-center p-8">
        <div className="w-full max-w-md">
          <div className="mb-8 lg:hidden">
            <h1 className="text-4xl font-bold text-white font-heading tracking-tight">Eva</h1>
            <p className="text-xs text-slate-500 uppercase tracking-widest mt-1">by ASAP Technologies</p>
          </div>

          <div className="mb-8">
            <h2 className="text-2xl font-bold text-white font-heading tracking-tight mb-2">Connexion</h2>
            <p className="text-sm text-slate-400">Accédez à votre espace de recrutement</p>
          </div>

          <form onSubmit={handleSubmit} data-testid="login-form">
            <div className="mb-5">
              <label className="eva-label">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="eva-input"
                required
                data-testid="email-input"
                placeholder="votre@email.com"
              />
            </div>

            <div className="mb-5">
              <label className="eva-label">Mot de passe</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="eva-input"
                required
                data-testid="password-input"
                placeholder="••••••••"
              />
            </div>

            <div className="flex items-center justify-between mb-6">
              <label className="flex items-center gap-2 cursor-pointer">
                <input
                  type="checkbox"
                  checked={resterConnecte}
                  onChange={(e) => setResterConnecte(e.target.checked)}
                  data-testid="remember-me-checkbox"
                  className="w-4 h-4 rounded border-white/20 bg-transparent"
                />
                <span className="text-sm text-slate-400">Rester connecté</span>
              </label>

              <Link to="/forgot-password" className="text-sm text-blue-400 hover:text-blue-300 transition-colors" data-testid="forgot-password-link">
                Mot de passe oublié ?
              </Link>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="eva-btn-primary w-full"
              data-testid="login-submit-button"
            >
              {loading ? 'Connexion...' : 'Se connecter'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};
